'use client'

import { GoalProps } from '@/widgets/landing-page-widgets/hero-section/schema'
import { Button, Typography } from '@pw-tech/omni-ui'
import GoalSelectionCard from './GoalSelectionCard'


const SelectGoalStep = ({
  handleNext,
  selectedGoal,
  handleGoalSelection,
  goals,
}: {
  handleNext: () => void
  selectedGoal: GoalProps
  handleGoalSelection: (x: GoalProps) => void
  goals: GoalProps[]
}) => {
  return (
    <div className="flex flex-col">
      <Typography variant='heading4' weight='bold' className="text-center" color='#3d3d3d'>
        Pick a learning program for your child
      </Typography>

      <div className="md:gap-6 gap-4 flex flex-col mt-4 md:mt-6">
        <div className="flex md:grid md:grid-cols-3 flex-col justify-between gap-4">
          {goals?.map((goal: GoalProps) => (
            <GoalSelectionCard
              key={goal?.cohortId}
              data={goal}
              selectedGoal={selectedGoal}
              handleGoalSelection={handleGoalSelection}
            />
          ))}
        </div>
        <div className="flex items-center justify-center">
          <Button className="md:w-[220px] w-full bg-gradient-to-b from-[#ff9d5b] to-[#ff6d0a]" variant='primary' onClick={handleNext}>
            Next
          </Button>
        </div>
      </div>
    </div>
  )
}

export default SelectGoalStep
